/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import Cookies from "js-cookie";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import {  Alert } from "react-bootstrap";
import { Grid, withStyles,Switch, InputLabel } from "@material-ui/core";
import {
    Paper,
    Tabs,
    Tab,
    Typography
} from "@material-ui/core";
import teal from "material-ui/colors/teal";

import PropTypes from "prop-types";
import { ApiDataNaturalNew } from "./ApiDataTable/ApiDataNaturalNew";
import { ApiDataLabNew } from "./ApiDataTable/ApiDataLabNew";
import { BsArrowLeftShort } from "react-icons/bs";
const CustomSwitch = withStyles({
    switchBase: {
      color: teal[300],
      '&$checked': {
        color: teal[500],
      },
      '&$checked + $track': {
        backgroundColor: teal[500],
      },
    },
    checked: {},
    track: {},
  })(Switch);
function TabContainer(props) {
    return (
        <Typography component="div">
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};


export const SupplierManagement = (props) => {
    const history = useHistory()
    const location = useLocation();

    const [value, setValue] = React.useState(0); // for tab

    function handleTabChange(event, newValue) {
        setValue(newValue);
    }
    const [feedsetting, setFeedSetting] = useState(null)
    const [offsuppliernaturalcount,setOffSupplierNaturalCount] = useState(0)
    const [offstonenaturalcount,setOffStoneNaturalCount] = useState(0)
    const [offsupplierlabgrowncount,setOffSupplierLabGrownCount] = useState(0)
    const [offstonelabgrowncount,setOffStoneLabGrownCount] = useState(0)
    const [mount,setMount] = useState(false)
    useEffect(() => {
        if (props.userinfo) {
            axios({
                method: "get",
                url: `${NODE_API_URL}/INTL/fetch-iframeorapi`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
                },
            }).then(supreq => {
                if (supreq && supreq.data && supreq.data.data) {
                    // setFeedLoader(false)
                    setFeedSetting(supreq.data.data)
                    if(supreq.data.data.allow_natural_rule && !value){
                        setValue(0)
                    }
                    else{
                        setValue(1)
                    }
                }
            }).
                catch(error => {
                    if (error?.response?.data?.message === "UnAuthorized!") {
                        var cookies = document.cookie.split(";");
                        for (var i = 0; i < cookies.length; i++) {
                            if (cookies[i] && !cookies[i].includes("view")) {
                                var equals = cookies[i].indexOf("=");
                                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                            }
                        }

                        window.location.replace(`${BASE_URL}/logout`);
                    }
                })
        }
    }, [props.userinfo,mount])
    useEffect(() => {
    // Early return if conditions aren't met
    if (!feedsetting?.api_id) return;

    const handler = setTimeout(() => {
        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/fetch-off-supplier-feed-count`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            },
            params: {
                api_id: feedsetting.api_id
            }
        }).then(supreq => {
            if (supreq?.data?.data) {
                for (let i = 0; i < supreq.data.data.length; i++) {
                    if (supreq.data.data[i].type === "Natural") {
                        setOffStoneNaturalCount(supreq.data.data[i].totaldiamonds || 0);
                        setOffSupplierNaturalCount(supreq.data.data[i].totalsuppliers || 0);
                    }
                    if (supreq.data.data[i].type === "Lab Grown") {
                        setOffStoneLabGrownCount(supreq.data.data[i].totaldiamonds || 0);
                        setOffSupplierLabGrownCount(supreq.data.data[i].totalsuppliers || 0);
                    }
                }
            }
        }).catch(error => {
            if (error?.response?.data?.message === "UnAuthorized!") {
                // Clear cookies and redirect
                document.cookie.split(";").forEach(cookie => {
                    if (!cookie.includes("view")) {
                        const equals = cookie.indexOf("=");
                        const name = equals > -1 ? cookie.substr(0, equals) : cookie;
                        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
                    }
                });
                window.location.replace(`${BASE_URL}/logout`);
            }
            // Consider adding additional error handling here
        });
    }, 300);

    return () => {
        clearTimeout(handler);
    };
}, [feedsetting,mount]); // Removed 'mount' unless it's necessary
    const FinalOk = (api_on_off,type) => {
            axios({
                method: "POST",
                url: `${NODE_API_URL}/INTL/turn-Onor-OffAll`,
                headers: {
                    "Content-Type": "application/json",
                     "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
                },
                data: {
                    api_id:feedsetting?.api_id,
                    type:type,
                    api_on_off:api_on_off
                },
            }).then(supreq => {
                if(supreq && supreq.data){
                    if(supreq.data){
                    setMount(!mount)
    
                    if(api_on_off === 1){
                        toast.success("Your All Feed Turn on")
                    }else{
                        toast.error("Your All Feed Turn Off")
                    }
                    }
                }
            }).
            catch(error => {
              if(error?.response?.data?.message === "UnAuthorized!"){
                var cookies = document.cookie.split(";");
              for (var i = 0; i < cookies.length; i++) {
                if(cookies[i] && !cookies[i].includes("view")){
                  var equals = cookies[i].indexOf("=");
                  var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                }
              }
              
              window.location.replace(`${BASE_URL}/logout`);
            }
            })
        }
    return (
        <>
            {feedsetting ? <div className="row">
                <div className="col-12 setting-title d-flex justify-content-between align-items-center">
                    Supplier Management
                    {feedsetting.api_plan !== "Basic"?
                    <div className="d-flex justify-content-center">
                            <Paper position="static" className="shadow-none border-bottom">
                                <Tabs value={value} indicatorColor="primary" textColor="primary" className="API_data" onChange={handleTabChange}>
                                    {feedsetting?.allow_natural_rule?<Tab label={props.language.DIAMOND_FEED_NATURAL_LISTING} />:""}
                                    {feedsetting?.allow_labgrown_rule?<Tab label={props.language.DIAMOND_FEED_LAB_LISTING} />:""}
                                </Tabs>
                            </Paper>
                        </div>
                        :null}
                    
                </div>
                <div className="col-12" >
                    {feedsetting.feed_type === "API" && feedsetting.api_live_mode !== 1 ?
                        <Alert variant="danger">
                            Once Testing is completed, Please contact to your sales administrator to Activate your Live API Key.
                        </Alert>
                        : ""}
                        {feedsetting.feed_type === "IFrame Plug-in" || feedsetting.api_plan === "API_V2"?<>
                            {value === 0 && (
                                <TabContainer >
                                    <ApiDataNaturalNew userinfo={props.userinfo} language={props.language} feedsetting={feedsetting} setMount={setMount} mount={mount} offsuppliernaturalcount={offsuppliernaturalcount} offstonenaturalcount={offstonenaturalcount}/>
                                </TabContainer>
                            )}
                            {value === 1 && (
                                <TabContainer >
                                    <ApiDataLabNew userinfo={props.userinfo} language={props.language} feedsetting={feedsetting} setMount={setMount} mount={mount} offsupplierlabgrowncount={offsupplierlabgrowncount} offstonelabgrowncount={offstonelabgrowncount}/>
                                </TabContainer>
                            )}
                        </>:feedsetting.api_plan !== "Basic"?<>
                            {value === 0 && (
                                <TabContainer >
                                    <ApiDataNaturalNew userinfo={props.userinfo} language={props.language} feedsetting={feedsetting} setMount={setMount} mount={mount} offsuppliernaturalcount={offsuppliernaturalcount} offstonenaturalcount={offstonenaturalcount}/>
                                </TabContainer>
                            )}
                            {value === 1 && (
                                <TabContainer >
                                    <ApiDataLabNew userinfo={props.userinfo} language={props.language} feedsetting={feedsetting} setMount={setMount} mount={mount} offsupplierlabgrowncount={offsupplierlabgrowncount} offstonelabgrowncount={offstonelabgrowncount}/>
                                </TabContainer>
                            )}
                        </>:
                        <div className="px-3 pb-10">
                            {feedsetting?.allow_natural_rule?<>
                            <Grid item xs={12} md={8} className="mt-8 ">
                                <Grid container spacing={3} alignItems="center">
                                    <Grid item xs={5}>
                                        <InputLabel className="font-size-h6 ">
                                            Natural Diamonds
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={6} className="d-flex align-items-center">
                                        <span className="font-weight-bold mr-3 mb-2" >Turn Off All</span>
                                        <label className="switch switch-sm">
                                            <input type="checkbox" className="success" checked={feedsetting.is_all_natural_supplier_on === 1} onClick={() => feedsetting.is_all_natural_supplier_on?FinalOk(2,"Natural"):FinalOk(1,"Natural")} />
                                            <span className="slider"></span>
                                        </label>
                                        <span className="font-weight-bold ml-3 mb-2" >Turn On All</span>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {offsuppliernaturalcount && offstonenaturalcount ? (
                                <div className="alert alert-warning p-3 d-flex align-items-center justify-content-between">
                                <div>
                                {offsuppliernaturalcount} supplier{offsuppliernaturalcount !== 1 ? 's' : ''} are off with {offstonenaturalcount} stone{offstonenaturalcount !== 1 ? 's' : ''}. Turn them on?
                                </div>
                                <button className="btn btn-sm btn-primary px-4" onClick={() => FinalOk(1,"Natural")}>
                                Yes
                                </button>
                            </div>
                            ) : ""}
                            </>:""}
                            <hr className="w-100 m-0 mt-8 mb-8" />
                            {feedsetting?.allow_labgrown_rule?<>
                            <Grid item xs={12} md={8} >
                                <Grid container spacing={3} alignItems="center">
                                    <Grid item xs={5}>
                                        <InputLabel className="font-size-h6 ">
                                            Lab Grown Diamonds
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={6} className="d-flex align-items-center">
                                        <span className="font-weight-bold mr-3 mb-2" >Turn Off All</span>
                                        <label className="switch switch-sm">
                                            <input type="checkbox" className="success" checked={feedsetting.is_all_labgrown_supplier_on === 1} onClick={() => feedsetting.is_all_labgrown_supplier_on?FinalOk(2,"Lab Grown"):FinalOk(1,"Lab Grown")} />
                                            <span className="slider"></span>
                                        </label>
                                            <span className="font-weight-bold ml-3 mb-2">Turn On All</span>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {offsupplierlabgrowncount && offstonelabgrowncount ? (
                            <div className="alert alert-warning p-3 d-flex align-items-center justify-content-between">
                                <div>
                                {offsupplierlabgrowncount} supplier{offsupplierlabgrowncount !== 1 ? 's' : ''} are off with {offstonelabgrowncount} stone{offstonelabgrowncount !== 1 ? 's' : ''}. Turn them on?
                                </div>
                                <button className="btn btn-sm btn-primary px-4" onClick={() => FinalOk(1,"Lab Grown")}>
                                Yes
                                </button>
                            </div>
                            ) : ""}
                            </>:""}
                        </div>}
                </div>
            </div> : ""}
        </>
    );
};